import classNames from 'classnames'
import i18next from 'i18next'
import { ReactNode } from 'react'
import { IconFa, Text } from '../../atoms'

export interface EventComponentProps {
  date: string
  createdBy?: string
  children: ReactNode
  icon: ReactNode
}

export const EventComponent = (props: EventComponentProps) => {
  return (
    <div className="bg-gray-100 p-4 rounded-xs">
      <div className="flex justify-between gap-4">
        {props.icon}
        <div>
          <Text className="mb-1 text-right" as="div" textType="sm">
            {props.date}
          </Text>
          {props.createdBy && (
            <Text as="div" textType="sm-black" className="text-right" semiBold>
              {props.createdBy}
            </Text>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-2 mt-2">{props.children}</div>
    </div>
  )
}

export const EventBodyParagraph = ({ text, className }: { text: ReactNode; className?: string }) => (
  <Text as="p" textType="sm" className={classNames(className, 'first-letter:uppercase')}>
    {text}
  </Text>
)

export const EventBodyImage = ({ src, filename }: { src: string; filename: string }) => (
  <div className="w-full max-h-[500px] bg-white">
    <img src={src} alt={String(filename)} />
  </div>
)

export const EventBodyLabelValue = ({
  label,
  value,
  className
}: {
  label: ReactNode
  value: ReactNode
  className?: string
}) => (
  <p className={classNames(className, 'first-letter:uppercase')}>
    <Text as="span" textType="sm" className="mr-1">
      {label}:
    </Text>
    <Text as="span" textType="sm-black">
      {value}
    </Text>
  </p>
)

export const EventBodyLabelFromToValue = ({
  label,
  from,
  to
}: {
  label: ReactNode
  from?: ReactNode
  to?: ReactNode
}) => (
  <p className="first-letter:uppercase">
    <Text as="span" textType="sm" className="mr-1 ">
      {label}:
    </Text>
    <Text as="span" textType="sm-black">
      {from ?? i18next.t('glow.blankText')}
    </Text>
    <IconFa icon={['far', 'arrow-right']} className="mx-2" />
    <Text as="span" semiBold textType="sm-black">
      {to ?? i18next.t('glow.blankText')}
    </Text>
  </p>
)
